import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
// -*- mode: jsx;-*-
import { Svg } from './Svg.js';
import PureRenderMixin from './external-adapters/pureRenderMixinAdapter.js';


window.DC_DEFAULT_PER_PAGE = 10;

export const Pagination = createReactClass({
    propTypes: {
        max: PropTypes.number,
        showNextButton: PropTypes.bool, // when max is missing, showNextButton is used
        page: PropTypes.number,
        url: PropTypes.string,
        changeURL: PropTypes.func,
        simplePagination: PropTypes.bool,
        perPage: PropTypes.number,
        isLoading: PropTypes.bool,
        vanityURL: PropTypes.string,
    },

    // We don't allow pagination deeper than 1k records 'cuz it's bad for solr perf
    ABSOLUTE_MAX_INDEX: 1000,

    getDefaultProps: function () {
        return {
            perPage: window.DC_DEFAULT_PER_PAGE,
            showNextButton: true,
            page: 1,
        };
    },

    mixins: [PureRenderMixin],
    paddingPages: 2,
    /**
     * How far ahead of the current page the user can get in one click.
     * Deep pagination in Solr is extremely resource intensive. We need to limit it for performance reasons.
     */
    lastPageOffsetLimit: function (currPage, numPages) {
        return Math.min(
            currPage === 1 ? 10 : currPage + 10,
            numPages,
        );
    },

    makePageLink: function (page, text, currPage, rel = null) {
        return <PageLink {...this.props} page={page} attributes={{ 'aria-label': 'ellipsis' }} text={'' + text} currPage={currPage} key={text}
            selected={page === currPage} rel={rel}/>;
    },

    makeEllipsis: function (number) {
        const key = 'ellipsis' + number;
        return (
            <Svg icon="ellipsis" key={key} attributes={{ 'aria-label': 'ellipsis' }}/>
        );
    },

    getMax: function () {
        if (this.props.max != null) {
            return this.props.max;
        }
        if (this.props.simplePagination) {
            return this.props.perPage * (this.props.page + (this.props.showNextButton ? 1 : 0));
        }
        return this.ABSOLUTE_MAX_INDEX;
    },

    render: function () {
        const props = this.props;
        const max = Math.min(this.getMax(), this.ABSOLUTE_MAX_INDEX);
        const numPages = Math.ceil(max / props.perPage);

        if (numPages < 2) {
            return null;
        }

        const currPage = props.page;
        const left = Math.max(currPage - this.paddingPages, 2);
        const right = Math.min(currPage + this.paddingPages, numPages - 1);
        const last = this.lastPageOffsetLimit(currPage, numPages);

        const pageLinks = [];
        if (currPage > 1 || props.simplePagination) {
            pageLinks.push(this.makePageLink(Math.max(currPage - 1, 1),
                "<svg class='icon icon-navigateleft'><use xlink:href='/images/icon/icon-junior.svg#icon-navigateleft'></use></svg>", currPage, 'prev'));
        }

        if (!props.simplePagination) {
            pageLinks.push(this.makePageLink(1, 1, currPage));

            if (left > 2) {
                pageLinks.push(this.makeEllipsis(1));
            }

            for (let i = left; i <= right; i++) {
                pageLinks.push(this.makePageLink(i, i, currPage));
            }

            if (right < numPages - 1) {
                pageLinks.push(this.makeEllipsis(2));
            }

            if (right < last) {
                pageLinks.push(this.makePageLink(last, last, currPage));

                if (last < numPages) {
                    pageLinks.push(this.makeEllipsis(3));
                }
            }
        }

        if (currPage < numPages || props.simplePagination) {
            pageLinks.push(this.makePageLink(Math.min((parseInt(currPage) + 1), numPages),
                "<svg class='icon icon-navigateright'><use xlink:href='/images/icon/icon-junior.svg#icon-navigateright'></use></svg>", currPage, 'next'));
        }

        return (
            <div className="pagination">
                <ul className="pages">
                    {pageLinks}
                </ul>
            </div>
        );
    },
});

export const PageLink = createReactClass({
    propTypes: {
        page: PropTypes.number.isRequired,
        text: PropTypes.string.isRequired,
        url: PropTypes.string,
        changeURL: PropTypes.func,
        onClick: PropTypes.func,
        isLoading: PropTypes.bool,
        vanityURL: PropTypes.string,
        rel: PropTypes.string,
        selected: PropTypes.bool,
    },

    mixins: [PureRenderMixin],
    pageURL: '',

    selectPage: function (event) {
        const props = this.props;
        if (!this.props.isLoading) {
            if (props.changeURL) {
                props.changeURL(this.pageURL);
            } else {
                $(window).trigger('changeURL', this.pageURL);
            }
        }
        event.preventDefault();
    },

    render: function () {
        const props = this.props;

        /* global Uri */
        const uri = new Uri(props.vanityURL || props.url || location.href);
        if (props.page > 1) {
            uri.replace('page', props.page);
        } else {
            uri.delete('page');
        }
        this.pageURL = uri.toString();

        let className;
        if (props.isLoading) {
            className = 'disabled';
        } else if (props.selected) {
            className = 'current';
        }

        return (
            <li className={className}>
                <a href={this.pageURL} onClick={props.onClick || this.selectPage} rel={props.rel} data-page={props.page} aria-label={'Navigate to page ' + props.page + 'of results'}
                    dangerouslySetInnerHTML={{ __html: props.text }}>
                </a>
            </li>
        );
    },
});
